export default __webpack_public_path__ + "static/media/getIn.778c3b69.mp3";